import { intlFormat, parseISO } from 'date-fns'
import { TimeHTMLAttributes, useEffect, useState } from 'react'

export interface DateDisplayProps
  extends TimeHTMLAttributes<HTMLElement> {
  /**
   * The date or time to display as an ISO
   * string
   *
   * eg: 2020-01-01T10:00
   */
  isoDateTime: string
  formatOptions?: Parameters<typeof intlFormat>[1]
  locale?: string
}

export function DateDisplay({
  isoDateTime,
  formatOptions,
  locale = 'en-GB',
  ...props
}: DateDisplayProps) {
  const [display, setDisplay] = useState('')
  const date = parseISO(isoDateTime)
  useEffect(() => {
    setDisplay(intlFormat(date, formatOptions ?? {}, { locale }))
  }, [date, formatOptions, isoDateTime, locale])
  return (
    <time dateTime={isoDateTime} title={isoDateTime} {...props}>
      {display}
    </time>
  )
}
